export const SERVICE_SECTORS = [
  "Освіта / Репетиторство",
  "Будівництво та ремонт",
  "Побутові послуги",
  "Ремонт техніки",
  "Авто-послуги",
  "Краса та здоров’я",
  "Фото / Відео / Аудіо",
  "Маркетинг / Дизайн / IT",
  "Транспорт / Переїзди / Доставка",
  "Події та свята",
  "Юридичні та бухгалтерські",
  "Тварини (грумінг/догляд)",
  "Спорт / Тренерство / Коучинг",
  "Інше",
];

const SUBSECTORS_BY_SECTOR = {
  "Освіта / Репетиторство": [
    "Мови", "Шкільні предмети", "Підготовка до іспитів",
    "IT / Програмування", "Музика / Мистецтво", "Дошкільна освіта", "Інше"
  ],
  "Будівництво та ремонт": [
    "Муляр / Штукатур / Плиточник", "Малярні роботи", "Електрик", "Сантехнік",
    "Столяр / Мебляр", "Дах / Фасад", "Вікна / Двері / Балкони",
    "Демонтаж / Монтаж", "Дизайн інтер’єру", "Інше"
  ],
  "Побутові послуги": [
    "Прибирання", "Прання / Прасування", "Майстер на годину",
    "Збірка меблів", "Дрібний ремонт у домі", "Інше"
  ],
  "Ремонт техніки": [
    "Смартфони / Планшети", "Ноутбуки / ПК", "Побутова техніка",
    "ТВ / Аудіо", "Інша електроніка", "Інше"
  ],
  "Авто-послуги": [
    "СТО (ремонт/діагностика)", "Шиномонтаж / Балансування",
    "Автоелектрика / ЕБУ", "Детейлінг / Хімчистка", "Автоскло",
    "Евакуатор", "Інше"
  ],
  "Краса та здоров’я": [
    "Перукар / Барбер", "Манікюр / Педикюр", "Макіяж / Брови / Вії",
    "Косметологія", "Масаж", "Психолог / Психотерапевт", "Дієтолог", "Інше"
  ],
  "Фото / Відео / Аудіо": [
    "Фотозйомка", "Відеозйомка", "Монтаж / Обробка",
    "Друк / Фотокниги", "Діджей / Звук / Світло", "Інше"
  ],
  "Маркетинг / Дизайн / IT": [
    "SMM / Контент", "Таргет / Реклама", "Брендинг / Графдизайн",
    "UX/UI", "Веб-розробка", "SEO", "Копірайтинг", "Інше"
  ],
  "Транспорт / Переїзди / Доставка": [
    "Переїзди", "Вантажні перевезення", "Пасажирські", "Кур’єр / Доставка", "Інше"
  ],
  "Події та свята": [
    "Організатор", "Ведучий", "Декор / Флористика",
    "Музиканти / Діджей", "Оренда реквізиту / Фотозона", "Інше"
  ],
  "Юридичні та бухгалтерські": [
    "Юрист / Адвокат", "Нотаріальні послуги (посередництво)",
    "Бухгалтерія / ФОП", "Податки / Аудит", "Інше"
  ],
  "Тварини (грумінг/догляд)": [
    "Грумінг", "Дресирування", "Перетримка / Готель", "Вигул", "Інше"
  ],
  "Спорт / Тренерство / Коучинг": [
    "Персональний тренер", "Групові тренування", "Йога / Пілатес",
    "Танці", "Кар’єрний / Лайф-коуч", "Інше"
  ],
  "Інше": ["Інше"]
};

export const servicesFields = (attrs) => {
  const a = attrs || {};
  const sector = a.sector || "";

  const sectorOnly = [
    {
      name: "sector",
      label: "Галузь *",
      type: "select",
      options: SERVICE_SECTORS,
      required: true,
    },
  ];
  if (!sector) return sectorOnly;

  const subsectors = SUBSECTORS_BY_SECTOR[sector] || [];

  return [
    ...sectorOnly,
    ...(subsectors.length
      ? [{
          name: "subsector",
          label: "Напрям",
          type: "select",
          options: subsectors,
          required: false,
        }]
      : []),

    {
      name: "availability",
      label: "Формат роботи",
      type: "select",
      options: ["Виїзд до клієнта", "У себе", "Онлайн", "Будь-який формат"],
    },
    {
      name: "priceType",
      label: "Формат оплати",
      type: "select",
      options: ["За годину", "За день", "За роботу", "Договірна"],
    },
    {
      name: "experience",
      label: "Досвід роботи",
      type: "select",
      options: ["<1 року", "1-3 роки", "3-5 років", "5+ років"],
    },
  ];
};
